import { render, staticRenderFns } from "./RecoveryBonusPart.vue?vue&type=template&id=61f66194&"
import script from "./RecoveryBonusPart.vue?vue&type=script&lang=js&"
export * from "./RecoveryBonusPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61f66194')) {
      api.createRecord('61f66194', component.options)
    } else {
      api.reload('61f66194', component.options)
    }
    module.hot.accept("./RecoveryBonusPart.vue?vue&type=template&id=61f66194&", function () {
      api.rerender('61f66194', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/RecoveryBonusPart.vue"
export default component.exports